import IconUserStatus from '../IconUserStatus';
import UserStatusCongratulationsIconBackground from './UserStatusCongratulationsIconBackground';
import { useSelector } from 'react-redux';
import { getAppUser } from '../../../app/appSelectors';
import classNames from 'classnames';
import { getIsLocationPlatformDesktopSelector } from '../../Location/locationSelectors';

interface IUserStatusCongratulationsIconProps {
    className?: string,
}

function UserStatusCongratulationsIcon(props: IUserStatusCongratulationsIconProps) {
    const { className } = props;
    const profile = useSelector(getAppUser);
    const isDesktop = useSelector(getIsLocationPlatformDesktopSelector);

    return <div className={classNames('position-relative', className)}>
        <UserStatusCongratulationsIconBackground isDesktop={isDesktop} statusName={profile.user_status}/>
        <IconUserStatus name={profile.user_status} size={isDesktop ? 220 : 120}/>
    </div>;
}

export default UserStatusCongratulationsIcon;
